import { type ReactNode } from 'react';
import {
  NEW_GUARANTEED_TIME_TO_LOVE_HOMEOWNERS_LANDING_PAGE_EXPERIMENT,
  useIsClientReady,
  COOKIES_CONFIG,
} from '@belong/common';
import { Footer } from 'src/components/footer/footer';
import clsx from 'clsx';
import { parseCookies } from 'nookies';
import { Header } from 'src/components/header/header';
import { RegionSelectorButton } from 'src/components/header/region-selector-button/region-selector-button';
import { ReferralBanner } from 'src/features/homeowners/components/referral-banner/referral-banner';
import { useExperimentVariant } from 'src/hooks/use-experiment-variant';

/**
 * This component is used to switch between the old and new landing pages layout based on the experiment variant.
 * Not entirely sure why we need this but moving the switching logic to the page level causes a more/less expected hooks
 * than expected in the rendered output.
 * It appeared to be related to the useIsClientReady hook.
 *
 * Also, once we can be sure that this is the only way, perhaps we could create a wrapper that works whenever we need to
 * switch between different page variants until we can implement something like path rewriting right in the middleware.
 */
export function LandingPageLayoutSwitcher({ page }: { page: ReactNode }) {
  const isClientReady = useIsClientReady();

  const gttlLandingPageExperimentVariant = useExperimentVariant(
    NEW_GUARANTEED_TIME_TO_LOVE_HOMEOWNERS_LANDING_PAGE_EXPERIMENT.name,
  );

  const cookies = parseCookies();

  const comeFromMobileApp = Boolean(
    cookies[COOKIES_CONFIG.MOBILE_APP.name] === 'true',
  );

  return (
    <div
      className={clsx(
        'duration-hover relative flex min-h-full flex-col transition-all',
        isClientReady ? 'opacity-100' : 'opacity-0',
      )}
    >
      <ReferralBanner />
      {!comeFromMobileApp && (
        <div className="text-white">
          <Header
            {...(gttlLandingPageExperimentVariant === 'test'
              ? { variant: 'secondary' as const, theme: 'dark' as const }
              : { regionSelector: <RegionSelectorButton theme="light" /> })}
          />
        </div>
      )}
      <main className="flex-1">{page}</main>
      {!comeFromMobileApp && <Footer />}
    </div>
  );
}
